module.exports = __webpack_public_path__ + "static/media/New_York_Rangers.411cdeac.svg";